import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  CitizenshipStep,
  PepConnectionStep,
  PersonalDataStep,
  RegistrationAddressStep,
  TaxResidencyStep,
  ControlOverStep,
} from './steps';
import { RoutePage } from './types';

export const pagesMap: Partial<
  Record<OnboardingProcessStepNameType, RoutePage['component']>
> = {
  [OnboardingProcessStepNameType.LegalClientBeneficiaryPersonalData]:
    PersonalDataStep,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryCitizenships]:
    CitizenshipStep,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryTaxResidencies]:
    TaxResidencyStep,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryAddresses]:
    RegistrationAddressStep,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryPep]: PepConnectionStep,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryControlOverLegalClient]:
    ControlOverStep,
};
